module.exports = __webpack_public_path__ + "img/e96afe9557a5bf87a748238338095c39.png";